import dayjs from 'dayjs';
import 'dayjs/locale/th';
import buddhistEra from 'dayjs/plugin/buddhistEra';
import _ from 'lodash';
import dynamic from 'next/dynamic';
import { useRouter } from 'next/router';
import qs from 'qs';
import { useEffect, useRef, useState } from 'react';
import ReCAPTCHA from 'react-google-recaptcha';
import { FaAngleDown, FaAngleUp, FaBars, FaGripHorizontal, FaSearch, FaTimes } from 'react-icons/fa';
import HeaderSubscribe from 'src/2.0/subscribe/header-subscribe';
import WidgetSubscribe from 'src/2.0/subscribe/widget-subscribe';
import { APP_IMG, RECAPTCHA_SITE_KEY, SHOW_COMMEMORATE, SHOW_RIBBON } from 'src/constants';
import { SHOW_MEMBER } from 'src/services/member-auth/constants';
import { DATALAYER_TYPE, sendDataLayerGlobal } from 'src/utils/datalayer/send-datalayer';
import styled from 'styled-components';
// import { getSession } from '@auth0/nextjs-auth0';

// const WidgetLogin = dynamic(import('src/services/member-auth/components/widget-login'));
const WidgetFollow = dynamic(import('src/components/widgets/widget-follow'));
const CardSubMenu = dynamic(import('src/components/cards/card-sub-menu'));

dayjs.extend(buddhistEra);

function useOnClickOutsideExpand(ref, handler) {
  useEffect(() => {
    const listener = event => {
      if (!ref.current || ref.current.contains(event.target)) {
        return;
      }

      handler(event);
    };

    document.addEventListener('mouseleave', listener);

    return () => {
      document.removeEventListener('mouseleave', listener);
    };
  }, [ref, handler]);
}

function useOnClickOutsideExpandSub(ref, handler) {
  useEffect(() => {
    const listener = event => {
      if (!ref.current || ref.current.contains(event.target)) {
        return;
      }

      handler(event);
    };

    document.addEventListener('mouseleave', listener);

    return () => {
      document.removeEventListener('mouseleave', listener);
    };
  }, [ref, handler]);
}

function useOnClickOutsideMoreMenu(ref, handler) {
  useEffect(() => {
    const listener = event => {
      if (!ref.current || ref.current.contains(event.target)) {
        return;
      }

      handler(event);
    };

    document.addEventListener('mousedown', listener);
    document.addEventListener('touchstart', listener);

    return () => {
      document.removeEventListener('mousedown', listener);
      document.removeEventListener('touchstart', listener);
    };
  }, [ref, handler]);
}

function useOnClickOutsideSearch(ref, handler) {
  useEffect(() => {
    const listener = event => {
      if (!ref.current || ref.current.contains(event.target)) {
        return;
      }

      handler(event);
    };

    document.addEventListener('mousedown', listener);
    document.addEventListener('touchstart', listener);

    return () => {
      document.removeEventListener('mousedown', listener);
      document.removeEventListener('touchstart', listener);
    };
  }, [ref, handler]);
}

const Header = ({ data }) => {
  let newNavData = [];
  if (data === null) newNavData = new Array(11).fill('');
  const router = useRouter();
  const searchBoxRef = useRef();
  const recaptchaRef = useRef(null);

  const [toggleSearch, setToggleSearch] = useState(false);
  const [textSearch, setTextSearch] = useState(null);
  const [recaptchaBox, setRecaptchaBox] = useState(false);
  const [subToggle, setSubToggle] = useState({
    status: false,
    key: null
  });
  const [subToggleMoreMenu, setSubToggleMoreMenu] = useState({
    status: false,
    key: null
  });
  const [moreMenu, setMoreMenu] = useState(true);
  const [expandMobile, setExpandMobile] = useState(false);

  const expandBoxRef = useRef();
  const subExpandBoxRef = useRef();
  const moreMenuBoxRef = useRef();
  // const userAuth = useUser();
  // const session = getSession(context.req, context.res);
  // console.log('getSession :', getSession);

  useOnClickOutsideExpand(expandBoxRef, async () => {
    await setSubToggle({
      status: false,
      key: null
    });
  });

  useOnClickOutsideExpandSub(subExpandBoxRef, async () => {
    await setSubToggleMoreMenu({
      status: false,
      key: null
    });
  });

  useOnClickOutsideMoreMenu(moreMenuBoxRef, async () => {
    await setMoreMenu(true);
    await setExpandMobile(false);
  });

  useOnClickOutsideSearch(searchBoxRef, async () => {
    await setToggleSearch(false);
  });

  const handleSearch = e => {
    e.preventDefault();
    setRecaptchaBox(true);
  };

  const onReCAPTCHAChange = async captchaCode => {
    if (!captchaCode) return null;

    try {
      const response = await fetch('/api/search/recaptcha', {
        method: 'POST',
        body: JSON.stringify({ textSearch, captcha: captchaCode }),
        headers: {
          'Content-Type': 'application/json'
        }
      });
      if (response.ok) {
        setRecaptchaBox(false);
        const serachParams = {
          q: textSearch || ''
        };

        const params = qs.stringify(serachParams, {
          encodeValuesOnly: true,
          arrayFormat: 'brackets'
        });
        window.location.href = `/search?${params}`;
      } else {
        const error = await response.json();
        throw new Error(error.message);
      }
    } catch (err) {
      alert(err?.message || 'Something went wrong');
      setRecaptchaBox(false);
    } finally {
      recaptchaRef.current = null;
      setTextSearch(null);
      setRecaptchaBox(false);
    }
  };

  let cloneNavData = [];

  if (data !== null) {
    cloneNavData = [...data];
    newNavData = cloneNavData.splice(0, 13);
  }

  const dateNow = dayjs(new Date()).locale('th').format('วันdddd ที่ D MMMM BBBB ');

  const { cid } = router.query;
  // let dataNav = newNavData.filter(el => el.nameEng === 'news');
  // dataNav = dataNav[0]?.sub.concat({
  //   id: 0,
  //   nameTh: 'ข่าวทั้งหมด',
  //   nameEng: 'latest-news',
  //   link: '/category/latest-news',
  //   metaData: null,
  //   data: []
  // });
  // newNavData = newNavData.map(el => {
  //   if (el.nameEng === 'news') {
  //     return { ...el, sub: dataNav.sort((a, b) => a.id - b.id) };
  //   }
  //   return el;
  // });
  return (
    <>
      <div className='default-header'>
        <HeaderWrapper gray={SHOW_RIBBON === 'true'} className='header-wrapper'>
          <div className='header-wrapper'>
            <div className='top-header-wrapper'>
              <div className='top-header'>
                <div className='top-header-settrade'>
                  <p>{dateNow}</p>
                </div>
                {/* --------------------------------- FOLLOW --------------------------------- */}
                <WidgetFollow
                  //! DATALAYER
                  eventDataLayer={{
                    type: DATALAYER_TYPE.TRACK_POSITION,
                    router: router?.pathname,
                    position: 'on:header',
                    section: 'header'
                  }}
                  handleSearch={() => {
                    setToggleSearch(!toggleSearch);
                  }}
                />
              </div>
            </div>
            {/* ---------------------------------- LOGO ---------------------------------- */}
            <div className={`header-wrap ${SHOW_RIBBON === 'true' ? 'back-white' : ''}`}>
              <HeaderSubscribe />
            </div>

            {toggleSearch && (
              <div className='search-box-popup is-gray' style={{ filter: SHOW_COMMEMORATE === 'true' ? 'grayscale(0.7)' : '' }}>
                {recaptchaBox && (
                  <div className='recaptcha-box'>
                    <ReCAPTCHA ref={recaptchaRef} sitekey={RECAPTCHA_SITE_KEY} onChange={onReCAPTCHAChange} />
                  </div>
                )}
                <form onSubmit={handleSearch} className='search-box-input' ref={searchBoxRef}>
                  <input type='text' maxLength={150} onChange={e => setTextSearch(e.target.value)} className='search-input' placeholder='ค้นหา' />
                  <button type='submit' aria-label='Search Submit' className='search-submit'>
                    <FaSearch size={24} />
                  </button>
                </form>
              </div>
            )}
          </div>
        </HeaderWrapper>
      </div>
      <HeaderDesktop className='header-desktop' isCommemorate={SHOW_COMMEMORATE === 'true' ? 'true' : SHOW_RIBBON}>
        <div className='container'>
          <div className='row col-12 align-self-center justify-content-between'>
            <div className='col-12 align-self-center'>
              <nav className='row justify-content-between'>
                <ul className='--desktop col-12'>
                  {/* <li>
                    {SHOW_RIBBON === 'true' && (
                      <div className='ribbon'>
                        <img src={`${APP_IMG}/logo-ribbon-black-2.png`} alt='logo' width='30px' height='30px' />
                      </div>
                    )}
                  </li> */}
                  <li
                    className={`${router.asPath === '/' ? 'active' : ''}`}
                    onMouseOver={() => {
                      setSubToggle({ status: false, key: null });
                    }}
                  >
                    <a
                      href='/'
                      aria-label='กรุงเทพธุรกิจ'
                      title='กรุงเทพธุรกิจ'
                      //! DATALAYER
                      onClick={() =>
                        sendDataLayerGlobal({
                          type: DATALAYER_TYPE.TRACK_POSITION,
                          router: router?.pathname,
                          position: 'on:header',
                          section: 'header',
                          data: {
                            title: 'กรุงเทพธุรกิจ',
                            heading: 'กรุงเทพธุรกิจ'
                          }
                        })
                      }
                    >
                      <img
                        className='logo'
                        src={`${APP_IMG}/logo-primary.png`}
                        alt='logo'
                        width='100%'
                        height='100%'
                        style={{ filter: SHOW_RIBBON === 'true' ? 'brightness(0)' : SHOW_COMMEMORATE === 'true' ? 'grayscale(1)' : 'unset' }}
                      />
                    </a>
                  </li>
                  {newNavData.map((item, i) => (
                    <li key={i} className={`${item && cid === item.nameEng ? 'active' : ''}`} style={{ filter: SHOW_COMMEMORATE === 'true' ? 'grayscale(0.7)' : '' }}>
                      {item.sub.length > 0 ? (
                        <>
                          <a
                            key={i}
                            style={{ position: 'relative' }}
                            href={`/${item.link}`}
                            title={item?.nameTh}
                            onMouseOver={() => {
                              setSubToggle({ status: true, key: i });
                              setSubToggleMoreMenu({ status: false, key: null });
                            }}
                            //! DATALAYER
                            onClick={() =>
                              sendDataLayerGlobal({
                                type: DATALAYER_TYPE.TRACK_POSITION,
                                router: router?.pathname,
                                position: 'on:header',
                                section: 'header',
                                data: {
                                  title: item?.nameTh,
                                  heading: item?.nameTh
                                }
                              })
                            }
                          >
                            {item.nameTh}
                            {item.sub.length > 0 && <FaAngleDown size={14} />}
                          </a>
                          {subToggle?.status && subToggle?.key === i && (
                            <ul className={`expand-sub ${i > 5 ? '--right' : '--default'}`} ref={expandBoxRef} onMouseLeave={() => setSubToggle({ key: null, status: false })}>
                              <CardSubMenu
                                data={item?.sub}
                                heading={item?.nameTh}
                                //! DATALAYER
                                eventDataLayer={{
                                  type: DATALAYER_TYPE.TRACK_POSITION,
                                  router: router?.pathname,
                                  position: 'ใน:menubar',
                                  section: 'header'
                                }}
                              />
                            </ul>
                          )}
                        </>
                      ) : (
                        <a
                          href={`/${item.link}`}
                          onMouseOver={() => setSubToggle({ status: false, key: null })}
                          //! DATALAYER
                          onClick={() =>
                            sendDataLayerGlobal({
                              type: DATALAYER_TYPE.TRACK_POSITION,
                              router: router?.pathname,
                              position: 'on:header',
                              section: 'header',
                              data: {
                                title: item?.nameTh,
                                heading: item?.nameTh
                              }
                            })
                          }
                        >
                          {item.nameTh}
                        </a>
                      )}
                    </li>
                  ))}
                </ul>
                <button
                  className='col-auto mobile-menu'
                  style={{ filter: SHOW_COMMEMORATE === 'true' ? 'grayscale(0.7)' : '' }}
                  onClick={() => {
                    setMoreMenu(!moreMenu);
                    setExpandMobile(true);
                  }}
                >
                  <FaGripHorizontal />
                </button>
                {expandMobile ? (
                  <button className='col-auto mobile-menu --close' style={{ filter: SHOW_COMMEMORATE === 'true' ? 'grayscale(0.7)' : '' }} onClick={() => setExpandMobile(false)}>
                    <FaTimes />
                  </button>
                ) : (
                  <div className='col-auto mobile-menu show-mobile widget-login-wrapper'>{SHOW_MEMBER === 'true' && <WidgetSubscribe />}</div>
                )}
              </nav>
            </div>
          </div>
        </div>
        <nav className={`expand-more-menu ${moreMenu ? '--hide' : ''} ${expandMobile ? '--mobile' : ''}`} ref={moreMenuBoxRef}>
          {expandMobile && (
            <ul className='mobile'>
              {!_.isEmpty(newNavData) &&
                newNavData.map((item, i) => (
                  <li
                    key={i}
                    style={{ filter: SHOW_COMMEMORATE === 'true' ? 'grayscale(0.7)' : '' }}
                    onClick={() => {
                      setSubToggleMoreMenu({ status: true, key: i });
                      setSubToggle({ status: false, key: null });
                    }}
                  >
                    {item.sub.length > 0 ? (
                      <>
                        <a
                          key={i}
                          href={`/${item.link}`}
                          //! DATALAYER
                          onClick={() =>
                            sendDataLayerGlobal({
                              type: DATALAYER_TYPE.TRACK_POSITION,
                              router: router?.pathname,
                              position: 'on:header',
                              section: 'header',
                              data: {
                                title: item?.nameTh,
                                heading: `${item?.nameTh}`
                              }
                            })
                          }
                        >
                          {item.nameTh}
                        </a>
                        {item.sub.length > 0 && subToggleMoreMenu.status && subToggleMoreMenu.key === i ? (
                          <FaAngleUp size={12} onClick={() => setSubToggleMoreMenu({ key: null, status: false })} />
                        ) : (
                          <FaAngleDown size={12} />
                        )}
                        {subToggleMoreMenu.status && subToggleMoreMenu.key === i ? (
                          <div className='expand-sub-mobile'>
                            <ul>
                              {item.sub.map((subMenu, index) => (
                                <li key={index}>
                                  <a
                                    href={subMenu.link}
                                    //! DATALAYER
                                    onClick={() =>
                                      sendDataLayerGlobal({
                                        type: DATALAYER_TYPE.TRACK_POSITION,
                                        router: router?.pathname,
                                        position: 'on:header',
                                        section: 'header',
                                        data: {
                                          title: subMenu?.nameTh,
                                          heading: `${item?.nameTh}:${subMenu?.nameTh}`
                                        }
                                      })
                                    }
                                  >
                                    {subMenu.nameTh}
                                  </a>
                                </li>
                              ))}
                            </ul>
                          </div>
                        ) : null}
                      </>
                    ) : (
                      <a
                        href={`/${item.link}`}
                        //! DATALAYER
                        onClick={() =>
                          sendDataLayerGlobal({
                            type: DATALAYER_TYPE.TRACK_POSITION,
                            router: router?.pathname,
                            position: 'on:header',
                            section: 'header',
                            data: {
                              title: item?.nameTh,
                              heading: `${item?.nameTh}`
                            }
                          })
                        }
                      >
                        {item.nameTh}
                      </a>
                    )}
                  </li>
                ))}
            </ul>
          )}
        </nav>
      </HeaderDesktop>
      <HeaderMoblie className='header-mobile'>
        <div
          className='block-1'
          style={{ filter: SHOW_COMMEMORATE === 'true' ? 'grayscale(0.7)' : '' }}
          onClick={() => {
            setMoreMenu(!moreMenu);
            setExpandMobile(true);
          }}
        >
          <FaBars />
        </div>
        <a
          href='/'
          className='block-2'
          title='กรุงเทพธุรกิจ'
          //! DATALAYER
          onClick={() =>
            sendDataLayerGlobal({
              type: DATALAYER_TYPE.TRACK_POSITION,
              router: router?.pathname,
              position: 'on:header',
              section: 'header',
              data: {
                title: 'logo',
                heading: 'logo'
              }
            })
          }
        >
          {/* ขนาดคุมด้วย CSS อย่างเดียว ไม่สลับ element ตอน hydrate ป้องกัน CLS */}
          <img
            className='logo'
            src={`${APP_IMG}/new-logo-primary.svg`}
            alt='logo'
            width={170}
            height={43}
            fetchpriority='high'
            decoding='async'
            style={{
              filter: SHOW_RIBBON === 'true' ? 'brightness(0)' : SHOW_COMMEMORATE === 'true' ? 'grayscale(1)' : 'unset'
            }}
          />
        </a>
        {expandMobile ? (
          <div className='body-close'>
            <button className='col-auto mobile-menu --close' onClick={() => setExpandMobile(false)}>
              <FaTimes />
            </button>
          </div>
        ) : (
          <WidgetSubscribe className='block-3 --mobile' />
          // <div className='col-auto mobile-menu show-mobile widget-login-wrapper'>{SHOW_MEMBER === 'true' && <WidgetLogin sessionSevId={sessionSevId} />}</div>
        )}
        <ExpandMore
          isCommemorate={SHOW_COMMEMORATE === 'true' ? 'true' : SHOW_RIBBON}
          className={`expand-more-menu ${moreMenu ? '--hide' : ''} ${expandMobile ? '--mobile' : ''}`}
          ref={moreMenuBoxRef}
        >
          {expandMobile && (
            <ul className='mobile'>
              {!_.isEmpty(newNavData) &&
                newNavData.map((item, i) => (
                  <li
                    key={i}
                    style={{ filter: SHOW_COMMEMORATE === 'true' ? 'grayscale(0.7)' : '' }}
                    onClick={() => {
                      setSubToggleMoreMenu({ status: true, key: i });
                      setSubToggle({ status: false, key: null });
                    }}
                  >
                    {item.sub.length > 0 ? (
                      <>
                        <a
                          key={i}
                          href={`/${item.link}`}
                          //! DATALAYER
                          onClick={() =>
                            sendDataLayerGlobal({
                              type: DATALAYER_TYPE.TRACK_POSITION,
                              router: router?.pathname,
                              position: 'on:header',
                              section: 'header',
                              data: {
                                title: item?.nameTh,
                                heading: `${item?.nameTh}`
                              }
                            })
                          }
                        >
                          {item.nameTh}
                        </a>
                        {item.sub.length > 0 && subToggleMoreMenu.status && subToggleMoreMenu.key === i ? (
                          <FaAngleUp size={16} onClick={() => setSubToggleMoreMenu({ key: null, status: false })} />
                        ) : (
                          <FaAngleDown size={16} />
                        )}
                        {subToggleMoreMenu.status && subToggleMoreMenu.key === i ? (
                          <div className='expand-sub-mobile'>
                            <ul>
                              {item.sub.map((subMenu, index) => (
                                <li key={index} style={{ filter: SHOW_RIBBON === 'true' || SHOW_COMMEMORATE === 'true' ? 'grayscale(0.7)' : 'unset' }}>
                                  <a
                                    href={subMenu.link}
                                    //! DATALAYER
                                    onClick={() =>
                                      sendDataLayerGlobal({
                                        type: DATALAYER_TYPE.TRACK_POSITION,
                                        router: router?.pathname,
                                        position: 'on:header',
                                        section: 'header',
                                        data: {
                                          title: subMenu?.nameTh,
                                          heading: `${item?.nameTh}:${subMenu?.nameTh}`
                                        }
                                      })
                                    }
                                  >
                                    {subMenu.nameTh}
                                  </a>
                                </li>
                              ))}
                            </ul>
                          </div>
                        ) : null}
                      </>
                    ) : (
                      <a
                        href={`/${item.link}`}
                        //! DATALAYER
                        onClick={() =>
                          sendDataLayerGlobal({
                            type: DATALAYER_TYPE.TRACK_POSITION,
                            router: router?.pathname,
                            position: 'on:header',
                            section: 'header',
                            data: {
                              title: item?.nameTh,
                              heading: `${item?.nameTh}`
                            }
                          })
                        }
                      >
                        {item.nameTh}
                      </a>
                    )}
                  </li>
                ))}
            </ul>
          )}
        </ExpandMore>
      </HeaderMoblie>
    </>
  );
};
const HeaderDesktop = styled.div`
  &.header-desktop {
    min-height: 45px;
    border-top: 6px solid var(--border-gray);
    border-bottom: 1px solid ${props => (props?.isCommemorate === 'true' ? '#ababacff' : 'var(--primary-color)')};
    box-shadow: var(--box-shadow-header);

    background-color: var(--white-color);
    color: var(--text-color);
    font-family: 'DBHelvethaica', sans-serif;
    padding: 3px 0;
    position: sticky;
    top: 0;
    z-index: 10;
    ul {
      display: flex;
      align-items: baseline;
      list-style: none;
      margin-bottom: 0;
      padding-left: 20px;

      li {
        margin: 5px;
        font-weight: bold;
        cursor: pointer;

        img {
          max-height: 20px;
          width: auto;
        }

        &:hover {
          color: var(--secondary-gray);
        }

        a {
          color: var(--text-color);
          text-decoration: none;

          &:hover {
            color: var(--secondary-gray);
          }

          h2 {
            font-size: inherit;
            margin-bottom: 0;
            line-height: inherit;
          }

          /* svg {
          path {
            &:hover {
              fill: var(--secondary-gray);
            }
          }
        } */
        }
      }
    }
    @media (max-width: 475px) {
      min-height: 47px;
    }
    ul {
      &.--desktop {
        justify-content: space-between;
        padding: 0;
        li {
          position: relative;
          font-size: 20px;
          font-weight: 200;
          padding: 0px 5px;
          a {
            font-weight: 300;
            color: var(--text-color);
            &:hover {
              color: ${props => (props?.isCommemorate === 'true' ? '#959596ff' : 'var(--secondary-color)')};
            }
          }
          svg {
            margin: 0 0 2px 2px;
          }
          &.active {
            > a {
              color: ${props => (props?.isCommemorate === 'true' ? '#000000ff' : 'var(--primary-color)')};
              font-weight: 300;
            }
            a {
              &:hover {
                border-bottom: none;
              }
              ul {
                a {
                  color: var(--softblack-color);
                  &:hover {
                    color: var(--white-color);
                  }
                }
              }
            }
          }
        }
        @media (max-width: 1200px) {
          li {
            font-size: 16px;
          }
        }
        @media (max-width: 1080px) {
          display: none;
        }
      }
    }

    .mobile-menu {
      display: none;

      &.--close {
        background: transparent;
        border: none;
      }
      @media (max-width: 1080px) {
        display: block;
        padding: 8px 24px;
        background-color: #e6e6e6;
        color: #0600e7;
        margin: -3px 0;
        font-size: 16px;
        border: none;
        outline: none;
        overflow: unset;

        svg {
          margin-bottom: 8px;
        }
        // &:hover {
        //   color: #fff;
        //   background-color: #0600E7;
        // }

        &.--close {
          background-color: #ec1818;
          color: #fff;

          &:hover {
            color: #fff;
            background-color: #2a2a2a;
          }
        }
      }
    }
  }
  @media (max-width: 1080px) {
    display: none;
  }
`;
const HeaderWrapper = styled.header`
  width: 100%;
  font-family: 'DBHelvethaica', sans-serif;
  background-color: #fff;
  color: #000;
  margin: auto;
  padding: 0px;
  align-items: center;
  z-index: 25;
`;
const ExpandMore = styled.div`
  background-color: #ffff;
  color: var(--text-color);
  position: absolute;
  z-index: 1001;
  top: 70px;
  left: 0;
  width: 100%;
  box-shadow: 2px 5px 7px rgba(0, 0, 0, 0.1);

  &.--mobile {
    width: 100%;
  }

  ul {
    max-width: 1280px;
    margin: auto;
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    padding: 5px 0px;

    li {
      a {
        color: var(--text-color);
        font-weight: 400;
        font-size: 22px;
      }
    }

    &.mobile {
      position: relative;
      padding: 15px;
      overflow-y: scroll;

      li {
        //display: flex;
        //justify-content: space-between;
        width: 100%;
        margin-bottom: 15px;
        color: #fff;
        border-bottom: 1px solid ${props => (props?.isCommemorate === 'true' ? '#1c1c1cff' : 'var(--primary-color)')};
        list-style-type: none;

        &:hover {
          a {
            color: #909090;
          }
        }

        svg {
          float: right;
          background-color: #fff;
          color: ${props => (props?.isCommemorate === 'true' ? '#1c1c1cff' : 'var(--primary-color)')};
        }

        .expand-sub-mobile {
          ul {
            display: flex;
            flex-direction: row;
            flex-wrap: wrap;
            justify-content: flex-start;
            margin: 0px auto;
            &:hover {
              color: #2f2f2f;
            }
            padding-left: 40px;

            li {
              width: auto;
              padding: 3px 15px;
              border-bottom: none;
              border-radius: 6px;
              margin: 3px 6px;
              font-weight: 400;
              background-color: var(--primary-color);
              color: #ffff;
              list-style-type: none;
              &:hover {
                color: #fff;
                background: #000;

                a {
                  color: #fff;
                }
              }

              a {
                color: #fff;
                font-size: 16px;
              }
            }
          }
        }
      }
    }
  }

  &.--hide {
    display: none;
  }
`;
const HeaderMoblie = styled.div`
  display: none;
  /* กำหนดขนาดคงที่ทุก viewport ตั้งแต่ render แรก ป้องกัน CLS */
  .logo {
    width: 170px;
    max-width: 100%;
    height: auto;
    aspect-ratio: 170 / 43;
  }
  .logo-img {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
  }
  .show-mobile {
    display: block !important;
    overflow-x: hidden;
    @media (min-width: 1080px) {
      display: none !important;
    }
    #widget-login {
      padding-left: 0;
    }
  }
  .widget-login-wrapper {
    @media (max-width: 1080px) {
      overflow: unset;
    }
  }

  .btn-login {
    margin-top: 3px;
    svg {
      color: var(--primary-color);
      &:hover {
        color: var(--primary-color);
      }
    }
  }

  .body-close {
    display: flex;
    justify-content: right;
  }
  .--close {
    border: none;
    background-color: rgb(255, 255, 255);
    font-size: 28px;
    padding: 10px;
    svg {
      padding: 0 !important;
      color: var(--secondary-gray) !important;
    }
  }
  @media (max-width: 1080px) {
    display: grid;
    grid-template-columns: 1fr 2fr 1fr;
    grid-template-areas: 'block-1 block-2 block-3';
    position: sticky;
    top: 0;
    width: 100vw;
    background-color: var(--white-color);
    box-shadow: 0px 4px 10px 0px var(--border-gray);

    justify-content: space-around;
    align-items: center;
    z-index: 100;
    min-height: 70px;
    .logo {
      /* filter: brightness(0) invert(1); */
      margin: 10px 0px;
    }
    .block-1 {
      grid-area: block-1;
      background: transparent;
      border: unset;
      display: flex;
      justify-content: flex-start;
      padding-left: 10px;

      svg {
        color: var(--secondary-gray);
        font-size: 24px;
      }
    }
    .block-2 {
      grid-area: block-2;
      display: flex;
      justify-content: center;
      align-items: center;
    }
    .block-3 {
      grid-area: block-3;
      display: flex;
      justify-content: flex-end;
      padding-right: 5px;
      align-items: center;
      .button-subscribe {
        background: transparent;
        border: unset;
        color: var(--secondary-gray);
        width: auto;
      }
    }
  }
`;
export default Header;
